
        var result = require("!!../../../../node_modules/css-loader/index.js!./employee.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/employees/employee-details/employee.component.css
// module id = 2468
// module chunks = 1